import { useEffect } from 'react';

const SmartsuppChat = () => {
  useEffect(() => {
    const script = document.createElement('script');
    script.type = 'text/javascript';
    script.async = true;
    script.src = 'https://www.smartsuppchat.com/loader.js?';

    window._smartsupp = window._smartsupp || {};
    window._smartsupp.key = 'c27062ada923a45a1512f0ec1e7e135e1bdf7701';

    document.body.appendChild(script);

    return () => {
      // Nettoyage si nécessaire
      document.body.removeChild(script);
    };
  }, []);

  return null;
};

export default SmartsuppChat;
